import { render, staticRenderFns } from "./MenuModal.vue?vue&type=template&id=5407f76f&scoped=true&"
import script from "./MenuModal.vue?vue&type=script&lang=js&"
export * from "./MenuModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5407f76f",
  null
  
)

export default component.exports